import { PayloadAction } from '@reduxjs/toolkit';

import { ADGMLicenseType, AngelInvestorType } from 'packages/angel_investors_repository';
import { defaultAngelInvestorsADGMLicense, angelInvestorDef } from 'redux/utils';
import { DataPayload } from 'types/reduxTypes/ActionTypes';
import { SetADGMFieldType, SetFieldType, types } from './actions';

type MissingDetailsHook = {
  angelInvestor: AngelInvestorType,
  hasLicense: boolean,
  fileName: string,
  adgmLicense: ADGMLicenseType,
};

const initialState: MissingDetailsHook = {
  angelInvestor: angelInvestorDef,
  hasLicense: true,
  fileName: '',
  adgmLicense: defaultAngelInvestorsADGMLicense,
};

const handleSetAll = (state: MissingDetailsHook, payload: DataPayload<AngelInvestorType>) => ({
  ...state, angelInvestor: payload.data,
});

const handleSetField = (state: MissingDetailsHook, payload: SetFieldType) => ({
  ...state, angelInvestor: { ...state.angelInvestor, [payload.field]: payload.data },
});

const handleSetAdgmField = (state: MissingDetailsHook, payload: SetADGMFieldType) => ({
  ...state, adgmLicense: { ...state.adgmLicense, [payload.field]: payload.data },
});

const handleSetAdgmAll = (state: MissingDetailsHook, payload: DataPayload<ADGMLicenseType>) => ({
  ...state, adgmLicense: { ...state.adgmLicense, ...payload.data },
});

const handleSetHasLicense = (state: MissingDetailsHook, payload: DataPayload<boolean>) => ({
  ...state, hasLicense: payload.data,
});

const handleSetFileName = (state: MissingDetailsHook, payload: DataPayload<string>) => ({
  ...state, fileName: payload.data,
});

const reducer = (
  state: MissingDetailsHook,
  action: PayloadAction<
    | SetFieldType
    | DataPayload<AngelInvestorType | string | boolean | ADGMLicenseType>
    | SetADGMFieldType
  >,
) => {
  const { type, payload } = action;
  switch (type) {
    case types.SET_ALL: {
      return handleSetAll(state, <DataPayload<AngelInvestorType>>payload);
    }
    case types.SET_FIELD: {
      return handleSetField(state, <SetFieldType>payload);
    }
    case types.SET_ADGM_FIELD: {
      return handleSetAdgmField(state, <SetADGMFieldType>payload);
    }
    case types.SET_ADGM_ALL: {
      return handleSetAdgmAll(state, <DataPayload<ADGMLicenseType>>payload);
    }
    case types.SET_HAS_LICENSE: {
      return handleSetHasLicense(state, <DataPayload<boolean>>payload);
    }
    case types.SET_FILE_NAME: {
      return handleSetFileName(state, <DataPayload<string>>payload);
    }
    default:
      return state;
  }
}

export { reducer, initialState };
